<template>
  <div style="padding-top:56px;" v-if="!loading_zone">
    <div class="zone_banner">
      <div class="container clearfix">
        <div class="left">
          <img :src="zone_instance.logo_image" />
          <span>{{ zone_instance.name }}</span>
        </div>
        <div class="right">
          <van-button v-if="!isAlreadyJoin" round type="default" size="small" @click="checkUserLogin()">加入</van-button>
          <van-button v-else round type="default" size="small" disabled>已加入</van-button>
        </div>
      </div>
    </div>
    <curList :filters="filters"
             :showPrice="false"
             :zone_uuid="zone_instance.uuid"
             v-bind="$attrs"></curList>

    <!-- 用户信息 -->
    <van-popup v-model:show="joinModal.visible" position="right" :style="{ width: '100%', height: '100%' }">
      <van-nav-bar z-index="10" left-arrow title="加入" @click-left="joinModal.visible = false"></van-nav-bar>
        <van-form ref="joinForm">
          <h4 class="modal_title">个人信息</h4>
          <van-cell-group>
            <van-field
              required
              v-model.trim="joinModal.form.realname"
              name="work_place"
              label="姓名"
              :formatter="formatterTrim"
              placeholder="请输入姓名"
              :rules="rules.realname"
            />
            <van-field required name="job" label="职业">
              <template #input>
                <van-radio-group v-model.trim="joinModal.form.job" direction="horizontal">
                  <van-radio name="office">职员</van-radio>
                  <van-radio name="student">学生</van-radio>
                  <van-radio name="teacher">教师</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              required
              v-model.trim="joinModal.form.work_place"
              name="work_place"
              :formatter="formatterTrim"
              label="单位/学校"
              placeholder="请输入单位/学校"
              :rules="rules.work_place"
            />
            <van-field
              required
              v-model.trim="joinModal.form.job_name"
              name="job_name"
              :formatter="formatterTrim"
              label="岗位/专业"
              placeholder="请输入岗位/专业"
              :rules="rules.job_name"
            />
            <h4 class="modal_title">授权信息</h4>
            <van-field
              required
              v-model.trim="joinModal.form.zone_user_code"
              name="zone_user_code"
              :formatter="formatterTrim"
              label="访问码"
              placeholder="请输入访问码"
              :rules="rules.zone_user_code"
            />
          </van-cell-group>
          <div style="margin: 16px;">
            <van-button block type="primary" native-type="submit" @click="submitForm('joinForm')">
              保存
            </van-button>
          </div>
        </van-form>
    </van-popup>
  </div>
</template>

<script>
  import CurList from "components/mobile/course/CurList"
  import { detailZone } from 'api/operation/zone/user'
  import { getUserInfo } from 'api/experiment/list'
  import { GetUserState } from 'api/user/auth/login'
  import { checkZoneUser } from 'api/experiment/list'
  import { updateUserLoginState } from 'api/user/auth/login'
  import { getUrlParam } from 'utils/common'

  export default {
    components: {
      CurList
    },
    data() {
      const checkInputRule = (value, rule) => {
        if(value.length >= 50) {
          return '字符长度限制在1到50个字符以内'
        }
        const iconFace = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
        if(iconFace.test(value)) {
          return '不能包含表情符号'
        }
        return true
      }
      return {
        preview_mode: false,
        loading_zone: true,
        zone_domain: null,
        zone_uuid: null,
        zone_instance: {},
        isAlreadyJoin: false,
        filters: {},
        // title: '',
        // originTitle: '',
        joinModal: {
          visible: false,
          form: {
            realname: '',
            job: 'office',
            work_place: '',
            job_name: '',
            zone_user_code: '',
            zone_id:'',
          }
        },
        rules: {
          realname: [
            { required: true, message: '请输入姓名', trigger: 'onBlur' },
            { validator: checkInputRule, trigger: 'onBlur' },
          ],
          job_name: [
            { required: true, message: '请输入岗位/专业', trigger: 'onBlur' },
            { validator: checkInputRule, trigger: 'onBlur' },
          ],
          work_place: [
            { required: true, message: '请输入学校/单位', trigger: 'onBlur' },
            { validator: checkInputRule, trigger: 'onBlur' },
          ],
          zone_user_code: [
            { required: true, message: '请输入访问码', trigger: 'onBlur' },
            { validator: checkInputRule, trigger: 'onBlur' },
          ]
        }
      }
    },
    async created() {

      this.init()

      if (this.$route.params.zone_domain != undefined) {
        this.zone_domain = this.$route.params.zone_domain;
        await this.getZoneDetail();
      }
    },
    mounted() {
      this.checkzoneuser()
      this.$emit('update:isShowHeader', false);
    },
    methods: {
      async getZoneDetail(){

        const that = this;
        this.loading_zone = true;
        await detailZone(this.zone_domain).then(result=>{

          if (result.succeed) {

            let is_preview = getUrlParam('preview');
            if (is_preview === 'true') {
              this.preview_mode = true;
            }

            console.log('preview_mode', this.preview_mode)

            if ((this.preview_mode) ||
              (result.is_admin || (result.instance.is_enabled && result.instance.service_state_const === 2))) {
              this.zone_instance = result.instance;
              this.zone_uuid = result.instance.uuid;
              console.log(this.zone_instance);
              that.loading_zone = false;
              this.$emit('update:isShowHeader', true);

            } else {
              window.location.href = '/404';
            }

          } else {

            switch (result.error_code) {
              case 0x02: {
                window.location.href = '/404';
              } break;
              default: {

                that.$notify({
                  title: '提示',
                  message: result.error_msg,
                  type: 'warning'
                });

                that.loading_zone = false;

              } break;
            }

          }

        }).catch(err=>{
          if (!err.__CANCEL__) {

            that.$notify({
              title: '提示',
              message: err,
              type: 'warning'
            });

          }

          that.loading_zone = false;

        })
    },
      formatterTrim(value) {
        // 过滤空格
        return value.replace(/^ +| +$/g, '');
      },
      init() {
        this.filters = {}
        let keys = Object.keys(this.$route.query)
        //标签页title
        // if(this.$route.query.price === 'free') {
        //   document.title = '免费课程-未来网络学堂';
        //   this.title = this.originTitle = '免费课程'
        // }
        // else if(this.$route.query.sort === 'new') {
        //   document.title = '最新课程-未来网络学堂';
        //   this.title = this.originTitle = '最新课程'
        // }
        if(keys.indexOf('price') >= 0){
          this.filters['final_price'] = 0
        }
        else if(keys.indexOf('sort') >= 0){
          this.filters['final_price'] = '>0'
          this.filters['sort_key'] = 'publish_at'
        }
        else if(keys.indexOf('query') >= 0){
          this.filters['query'] = this.$route.query.query
          // document.title = '课程搜索-未来网络学堂'
          // if(this.filters['query'] === '') {
          //   this.title = this.originTitle
          // } else {
          //   this.title = '搜索：' + this.filters['query']
          // }
        }

        //reload 7moor js
        // const s = document.createElement('script');
        // s.type = 'text/JavaScript';
        // s.src = 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=a4c3d330-5dcc-11ea-b7ff-07dd5ece4b95&autoShow=true&language=ZHCN';
        // document.body.appendChild(s);
      },
      submitForm(formName) {
        const that = this;
        this.$refs[formName].validate().then(()=>{
          getUserInfo(this.joinModal.form).then((res) => {
              if(res.succeed){
                  this.isAlreadyJoin = true
                  console.log('保存成功')
              } else {
                if(res.error_code == 1){
                    that.$emit('update:loginVisible', true)
                }else{
                  this.$dialog.alert({
                        title: '提示',
                        message: res.error_msg,
                  })
                }
              }
            })
            this.joinModal.visible = false
        }).catch(()=>{

        })
      },
      getuserstate(){
        GetUserState().then(res=>{
          if(res){
              this.joinModal.form.realname = res.realname;
              this.joinModal.form.job = res.job;
              this.joinModal.form.work_place = res.work_place;
              this.joinModal.form.job_name = res.job_name;
              this.joinModal.form.zone_id = this.zone_instance.id;
          }
        })
      },
      checkUserLogin() {
        let that = this;
        updateUserLoginState().then((res) => {
          if (res.hasOwnProperty("error") && res.error === 'Not Login State') {
            that.$emit('update:loginVisible', true)
          }else{
            this.getuserstate()
            that.joinModal.visible = true
          }
        }).catch(error => {

        });
      },
      checkzoneuser(){
        checkZoneUser({'domain':this.zone_domain}).then((res) => {
            if (res.code == 1){
              this.isAlreadyJoin = true
            }else{
              this.isAlreadyJoin = false
            }
        })
      },
    },
    watch: {
      '$route' (to, from) {
        if(to.name === 'CourseSearch'){
          this.init()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.zone_banner {
  position: fixed;
  top:60px;
  left:0;
  right:0;
  z-index: 1;
  .container {
    background:#0071c5;
    height: 56px;
    display: flex;
    .left {
      flex: 1;
      display: flex;
      padding-right: 20px;
      align-items: center;
      overflow:hidden;
    }
    img {
      height:22px;
      vertical-align: middle;
      margin-right:10px;
    }
    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
      color:#fff;
      font-size:16px;
    }
    .van-button {
      min-width:60px;
      padding: 5px;
      font-size: 14px;
      letter-spacing: 0.1rem;
      border: none;
      color: #0071c5;
      height: auto;
    }
  }
}
.modal_title {
  margin: 15px;
}
</style>

